import PlayApps from '@crehana/compass.icons.fill/PlayApps';
import { cn } from '@crehana/compass.ui/v2';

type TLessonVideoItemProps = {
  title: string;
  duration: string;
  className?: string;
};

const LessonVideoItem: React.FC<TLessonVideoItemProps> = ({
  title,
  duration,
  className,
}) => {
  return (
    <li
      className={cn(
        'tw-flex tw-items-center tw-w-full tw-text-left focus:tw-outline-none',
        className,
      )}
      data-cy="course-lesson"
    >
      <p className="tw-flex tw-gap-1.2 tw-items-center tw-justify-between tw-w-full">
        <PlayApps
          size={16}
          className="tw-flex-none tw-text-neutral-light-800"
        />
        <span className="tw-flex-grow tw-font-body5">{title}</span>
        <span className="tw-self-end tw-font-body5">{duration}</span>
      </p>
    </li>
  );
};

export default LessonVideoItem;
